export default "__VITE_ASSET__BQiB3gEt__"